import { Component, For, onMount, Show } from "solid-js"
import { Artwork } from "../types";
import { fetchGet } from "../api";
import { createStore } from "solid-js/store";
import { Img } from "../components/universal/image";

type Props = {
    data: Artwork;
}

type State = {
    isContentReady: boolean;
}
type _Artist = {
    Id: string;
    Slug: string;
    Name: string;
}
type _Artwork = {
    Id: string;
    Title: string;
    Slug: string;
    Artist: _Artist;
    PrimaryImage: _NewImage;
}
type _NewImage = {
    Id: string;
    URL: string;
    Width: number;
    Height: number;
}
type Relationship = {
    Name: string;
    Artworks: _Artwork[];
}
type Relationships = {
    Source: Relationship[];
    Target: Relationship[];
}
type ArtistRelationsProps = {
    relationships: Relationship[];
}

const ArtistRelations : Component<ArtistRelationsProps> = ({ relationships }) =>{
    return (
        <div>
            <For each={relationships}>{(item) => 
                <div>
                    <h3 style="color: #333;">
                        {item.Name} ...
                    </h3>
                    <div>
                        <For each={item.Artworks}>{(artwork) =>
                            <div style="display: inline-block; margin: 10px; vertical-align: top; width: 200px;">
                                <div style="width: 100%;">
                                    <a href={`/artworks/${artwork.Slug}/${artwork.Artist.Slug}/${artwork.Id}`}>
                                        <Show when={artwork.PrimaryImage}>
                                            <Img src={artwork.PrimaryImage.URL} mode="crop" width={200} style="width: 200px;" />
                                        </Show>
                                        <Show when={!artwork.PrimaryImage}>
                                            <span>[ no image ]</span>
                                        </Show>
                                    </a>
                                </div>
                                <div style="width: 100%; background-color:#efefef; padding: 3px;">
                                    <h4 innerHTML={artwork.Title}></h4>
                                    <p>
                                        by <a href={`/artists/${artwork.Artist.Slug}/${artwork.Artist.Id}`}><span innerHTML={artwork.Artist.Name}></span></a>
                                    </p>
                                </div>
                            </div>
                        }</For>
                    </div>
                </div>
            }</For>
        </div>
    );
}

export const RelationshipsTab : Component<Props> = (props) => {
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [relationships, setRelationships] = createStore<Relationships>({ Source: [], Target: [] });
    const loadRelationships = async () => {
        const res = await fetchGet("/Artwork/GetRelationshipsJson", { id: props.data.id });
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        setRelationships("Source", json.Data.Source);
        setRelationships("Target", json.Data.Target);
        setState({ isContentReady: true });
    };
    onMount(async () => {
        await loadRelationships();
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div style="text-align: left; padding: 20px; background-color: #fff; border-radius: 5px;">
                    <Show when={relationships.Source.length}>
                        <ArtistRelations relationships={relationships.Source} />
                    </Show>
                    <Show when={relationships.Target.length}>
                        <ArtistRelations relationships={relationships.Target} />
                    </Show>
                </div>
            </Show>
        </>
    )
}